import { Form } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';

import { LoadingSelect } from 'components/forms/LoadingFields';

import ScriptEditor from '../ui/ScriptEditor';
import type { EditableNodeDefinition } from '../../edit/EditableNodeDefinition';

// Shell flavour options. Model-bound (entity.subType) rather than bridged like the config fields below, since sub_type is a
// top-level node-definition field — it lives here (not on the generic Definition tab) because it only applies to shell nodes.
const SUB_TYPE_OPTIONS = [
  { value: 'bash', label: 'bash' },
  { value: 'ksh', label: 'ksh' },
  { value: 'cmd', label: 'cmd' },
  { value: 'pwsh', label: 'pwsh' },
];

interface Props {
  readonly entity: EditableNodeDefinition;
  readonly state: any;
  readonly onChange: (e: any, isConfig?: boolean) => void;
  readonly readOnly?: boolean;
}

const Bash = observer(({ entity, state, onChange, readOnly = false }: Props) => {
  const { script, run_as_user, nr_of_lines_to_load } = state.config || {};

  return (
    <>
      <LoadingSelect
        label="Shell type"
        controlId="form-SubType"
        name="sub_type"
        value={entity.subType || 'bash'}
        onChange={(e) => (entity.subType = e.target.value)}
        isLoading={false}
        options={SUB_TYPE_OPTIONS}
        groupClassName="mb-2 w-25"
        placeholder="Select sub type"
        aria-label="Select sub type"
        disabled={readOnly}
      />

      <Form.Group className="mb-2 w-full" controlId="formNode-run_as_user">
        <Form.Label>Run as user</Form.Label>
        <Form.Control type="text" name="run_as_user" value={run_as_user || ''} onChange={(e) => onChange(e, true)} disabled={readOnly} />
      </Form.Group>

      <Form.Group className="mb-2 w-full" controlId="formNode-nr_of_lines_to_load">
        <Form.Label>Number of lines to load</Form.Label>
        <Form.Control type="text" name="nr_of_lines_to_load" value={nr_of_lines_to_load || ''} onChange={(e) => onChange(e, true)} disabled={readOnly} />
      </Form.Group>

      <ScriptEditor
        label="Script"
        controlId="formNode-script"
        name="script"
        value={script || ''}
        language="shell"
        onChange={(e) => onChange(e, true)}
        readOnly={readOnly}
        aria-label="Script editor"
      />
    </>
  );
});

export default Bash;
